import React from 'react';
import {
    TableHead,
    TableRow,
    TableCell,
    TableSortLabel,
    Checkbox,
    Box,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';

const headCells = [
    { id: 'id', numeric: false, label: 'ID' },
    { id: 'merchant', numeric: false, label: 'Merchant' },
    { id: 'email', numeric: false, label: 'Email/Mobile' },
    { id: 'start_date', numeric: false, label: 'Start Date' },
    { id: 'area_per_sqft', numeric: true, label: 'Area (sqft)' },
    { id: 'price_per_sqft', numeric: true, label: 'Price (sqft)' },
    { id: 'status', numeric: false, label: 'Status' },
];

export default function MerchantWarehouseTableHead(props) {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
                <TableCell align="left" sx={{ position: 'sticky', right: 0, zIndex: 10, background: '#fff' }}>Action</TableCell>
            </TableRow>
        </TableHead>
    );
}
